import useRoomBaseServer from '../room/roombase.server';
import interactRewardApi from '../../request/interactReward';
import useMsgServer from '../common/msg.server';
import BaseServer from '../common/base.server';

class InteractRewardServer extends BaseServer {
  constructor(opt = {}) {
    super();
    const watchInitData = useRoomBaseServer().state.watchInitData;
    this._roomId = watchInitData.interact.room_id;
    this._webinarId = watchInitData.webinar.id;
    this.state = {}
    this.listenMsg();
  }
  //对外暴露通知名称
  Events = {
    REWARD_WIN: 'interact_reward_winning_notice' // 获得礼品
  };


  // 监听消息
  listenMsg() {
    useMsgServer().$onMsg('ROOM_MSG', msg => {
      switch (msg.data.event_type || msg.data.type) {
        case this.Events.REWARD_WIN:
          this.$emit(this.Events.REWARD_WIN, msg);
          break;
      }
    });
  }

  // 获取互动有礼领奖页的设置信息
  getReceiveAwardSetting(interactRewardId) {
    return interactRewardApi.getReceiveAwardSetting({
      webinar_id: this._webinarId,
      interact_reward_id: interactRewardId
    });
  }

  // 获取中奖人信息
  getWinnerInfo(params) {
    return interactRewardApi.getWinnerInfo(params);
  }

  // 提交领奖信息（寄送奖品情况下才需要）
  saveAwardInfo(params) {
    return interactRewardApi.saveAwardInfo(params);
  }

  // 我的礼品
  getMyAwardList(params) {
    return interactRewardApi.getMyAwardList(params);
  }

};

export default function useInteractRewardServer(opt) {
  if (!InteractRewardServer.instance) {
    InteractRewardServer.instance = new InteractRewardServer(opt);
  }
  return InteractRewardServer.instance;
}
